import React from 'react';
import styles from './LogoMain.module.css';

const LogoMain = (props) => {
  return (
    <div className={styles.logoMain}>
        <img className='imagen-logo' src={require(`../img/logos/01-logo-${props.imagen}.png`)}
            alt='logo main'
        />
    </div>
  );
};

export default LogoMain;